<template>
  <v-container id="forgot" class="fill-height" tag="section">
    <v-row justify="center">
      <v-form @submit.prevent="onRegister()">
        <v-slide-y-transition appear>
          <base-material-card
            color="success"
            light
            max-width="100%"
            :width="$vuetify.breakpoint.mdAndUp ? '800' : '100%'"
            class="px-5 py-3"
          >
            <template v-slot:heading>
              <div class="text-center">
                <h1 class="display-2 font-weight-bold mb-2">
                  {{ $t("register.title") }}
                </h1>
                <p>{{ $t("register.subtitle") }}</p>
              </div>
            </template>

            <v-card-text class="text-left">
              <h4 class="mt-3">{{ $t("register.common_data") }}</h4>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    color="secondary"
                    :label="$t('register.first_name')"
                    name="first_name"
                    v-model="model.first_name"
                    data-vv-name="first_name"
                    :error-messages="errors.collect('first_name')"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    color="secondary"
                    :label="$t('register.last_name')"
                    name="last_name"
                    v-model="model.last_name"
                    data-vv-name="last_name"
                    :error-messages="errors.collect('last_name')"
                  />
                </v-col>
              </v-row>

              <v-text-field
                color="secondary"
                :label="$t('register.tax')"
                name="tax"
                v-model="model.tax"
                data-vv-name="tax"
                :error-messages="errors.collect('tax')"
              />
              <v-row>
                <v-col>
                  <v-select
                    v-model="model.gender"
                    :items="[
                      { key: 'm', label: $t('men') },
                      { key: 'f', label: $t('woman') },
                      { key: 's', label: $t('divers') }
                    ]"
                    :label="$t('register.gender.title')"
                    disabled
                    name="gender"
                    item-text="label"
                    item-value="key"
                    data-vv-name="gender"
                    :error-messages="errors.collect('gender')"
                  ></v-select
                ></v-col>
                <v-col>
                  <DatePicker
                    :label="$t('register.birth')"
                    disabled
                    name="birth"
                    data-vv-name="birth"
                    v-model="model.birth"
                    :error-messages="errors.collect('birth')"
                  ></DatePicker>
                </v-col>
              </v-row>

              <v-spacer />

              <h4 class="mt-3">{{ $t("register.address") }}</h4>

              <v-row>
                <v-col cols="4">
                  <v-text-field
                    color="secondary"
                    :label="$t('register.plz')"
                    name="plz"
                    v-model="model.plz"
                    data-vv-name="plz"
                    :error-messages="errors.collect('plz')"
                  />
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    color="secondary"
                    :label="$t('register.place')"
                    name="place"
                    v-model="model.place"
                    data-vv-name="place"
                    :error-messages="errors.collect('place')"
                  />
                </v-col>
              </v-row>

              <v-text-field
                color="secondary"
                :label="$t('register.address')"
                name="address"
                v-model="model.address"
                data-vv-name="address"
                :error-messages="errors.collect('address')"
              />

              <v-spacer />

              <h4 class="mt-3">{{ $t("register.contact_data") }}</h4>

              <v-text-field
                color="secondary"
                :label="$t('register.phone')"
                name="phone"
                v-model="model.phone"
                data-vv-name="phone"
                :error-messages="errors.collect('phone')"
              />

              <v-spacer />

              <h4 class="mt-3">{{ $t("register.login_data") }}</h4>

              <v-text-field
                color="secondary"
                :label="$t('register.email')"
                name="email"
                v-model="model.email"
                data-vv-name="email"
                :error-messages="errors.collect('email')"
              />

              <v-text-field
                color="secondary"
                :label="$t('register.password')"
                name="password"
                type="password"
                v-model="model.password"
                data-vv-name="password"
                :error-messages="errors.collect('password')"
              />
              <v-text-field
                color="secondary"
                :label="$t('register.password_confirmation')"
                name="password_confirmation"
                type="password"
                v-model="model.password_confirmation"
                data-vv-name="password_confirmation"
                :error-messages="errors.collect('password_confirmation')"
              />

              <v-spacer />
              <h4 class="mt-5 pt-5">{{ $t("register.privacy_data") }}</h4>
              <a
                style="padding-top: 5px;display: block;"
                :href="$store.state.modules.options.app_privacy"
                target="_blank"
                >{{ $t("register.privacy.accept_agb_show") }}</a
              >

              <v-checkbox
                style="margin-top: 0px;"
                v-model="model.privacy_agb"
                name="privacy_agb"
                data-vv-name="privacy_agb"
                :error-messages="errors.collect('privacy_agb')"
                :label="$t('register.privacy.accept_agb')"
              >
              </v-checkbox>

              <template
                v-if="$store.state.modules.options.photo_privacy == '1'"
              >
                <v-spacer />

                <h4 class="mt-5 mt-5">
                  {{ $t("register.privacy.photo_title") }}
                </h4>

                <v-checkbox
                  v-model="model.privacy_photo"
                  :label="$t('register.privacy.photo_yes')"
                  :value="'yes'"
                  name="privacy_photo_yes"
                  data-vv-name="privacy_photo_yes"
                  :error-messages="errors.collect('privacy_photo')"
                ></v-checkbox>
                
                <v-checkbox
                  class="mt-0"
                  v-model="model.privacy_photo"
                  :label="$t('register.privacy.photo_no')"
                  :value="'no'"
                  name="privacy_photo_no"
                  data-vv-name="privacy_photo_no"
                  :error-messages="errors.collect('privacy_photo')"
                ></v-checkbox>
                <br><br>
              </template>

              <p>{{ $t("register.privacy.sign_here") }}</p>

              <VueSignaturePad
                width="100%"
                height="200px"
                :customStyle="{ border: 'black 2px solid' }"
                ref="signaturePad"
              />
              <a
                href="#"
                style="font-size: 12px;float:right"
                @click.prevent="$refs.signaturePad.undoSignature()"
              >
                {{ $t("register.privacy.sign_delete") }}</a
              >

              <div style="clear: both;margin-bottom: 30px;"></div>

              <div class="text-center mt-5">
                <pages-btn
                  large
                  color="success"
                  depressed
                  class="v-btn--text"
                  type="submit"
                >
                  {{ $t("register.button_submit") }}
                </pages-btn>
              </div>
            </v-card-text>
            <a @click="$router.push({ path: '/' })">
              {{ $t("back_to_home") }}
            </a>
            <br />
            <br />
            <br />
          </base-material-card>
        </v-slide-y-transition>
      </v-form>
    </v-row>
  </v-container>
</template>

<script>
import { registerUser } from "./shared/services";
import codiceFiscale from "codice-fiscale-js";
import Swal from "sweetalert2";

export default {
  name: "forgot",
  $_veeValidate: {
    validator: "new"
  },
  components: {
    DatePicker: () =>
      import("@/app/shared/components/template/base/DatePicker"),
    PagesBtn: () =>
      import("@/app/shared/components/template/pages/components/Btn")
  },
  data() {
    return {
      model: {
        email: null,
        tax: null,
        phone: null,
        plz: null,
        address: null,
        place: null,
        birth: null,
        gender: null,
        first_name: null,
        last_name: null,
        password: null,
        password_confirmation: null,
        privacy_agb: false,
        privacy_photo: null
      }
    };
  },
  watch: {
    "model.tax": function(data) {
      if (data.length == 0) {
        this.model.birth = null;
        this.model.gender = null;
        return;
      }
      try {
        if (data.length == 16) {
          var cf = new codiceFiscale(data.toUpperCase());
          this.model.tax = data.toUpperCase();
          this.model.birth = cf.birthday.toISOString().slice(0, 10);
          if (cf.gender == "M") {
            this.model.gender = "m";
          } else if (cf.gender == "F") {
            this.model.gender = "f";
          } else {
            this.model.gender = "s";
          }
        } else {
          throw new Error(
            "tax id != 16 length - length for (" + data + ") is =" + data.length
          );
        }
      } catch (e) {
        this.model.birth = null;
        this.model.gender = null;
      }
    }
  },
  methods: {
    onRegister() {
      if (this.model.birth == null) {
        Swal.fire({
          icon: "error",
          title: this.$t("Fehler"),
          text: this.$t("error_invalid_tax")
        });
        return;
      }

      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (isEmpty) {
        Swal.fire({
          icon: "error",
          title: this.$t("Fehler"),
          text: this.$t("error_missing_signature")
        });
        return;
      }

      registerUser({ ...this.model, signature: data }, this.$validator)
        .then(resp => {
          this.$auth.login({
            params: {
              email: this.model.email,
              password: this.model.password
            },
            redirect: { name: "frontend.my-family" },
            success: function() {
              this.$root.$notification(
                this.$t("register.register_success_message"),
                { type: "success" }
              );
            },
            error: function(error) {
              let errorMessages = [];
              for (let field in error.response.data.errors) {
                errorMessages.push(error.response.data.errors[field][0]);
              }
              this.$root.$notification(errorMessages.join(", "), {
                color: "error"
              });
            },
            rememberMe: true,
            fetchUser: true
          });
        })
        .catch(resp => {
          //console.log("catch resp", resp);
          // this.$root.$notification(resp.message, { color: "error" });
        });
    }
  }
};
</script>

<style lang="scss">
.v-select .v-select__selections {
  text-transform: none !important;
}
</style>
